<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
<div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 mb-4">
  <h4 class="position-relative text-black fw-bold mb-10">Files de Validation</h4>
  
  <div class="d-flex align-items-center gap-3">
    <!-- Recherche à droite -->
    <div class="search-box position-relative">
      <input
        type="text"
        v-model="searchRef"
        class="form-control shadow-none rounded border"
        placeholder="Rechercher par référence BESC..."
        style="min-width: 280px;"
      />
      <i class="flaticon-search-interface-symbol position-absolute top-50 end-0 translate-middle-y me-3 text-muted"></i>
    </div>

    <!-- Bouton Retour -->
    <router-link to="/dashboard" class="btn btn-primary transition border-0 lh-1 fw-medium">
      <i class="flaticon-left-arrow lh-1 me-1"></i>
      <span>Retour</span>
    </router-link>
  </div>
</div>
          

          <!-- Message si vide -->
          <div v-if="queues.length === 0" class="alert alert-info">
            <i class="flaticon-info-circle me-2"></i>
            Aucune file de validation trouvée.
          </div>

          <!-- Liste des files -->
          <div v-else class="queues-list">
           <div v-for="queue in queuesWithDossiers" :key="queue.id" class="queue-card mb-4"
  :class="getRiskCardClass(queue.maxRiskLevel)">
              <!-- En-tête de la carte -->
              <div class="queue-card-header d-flex align-items-center justify-content-between">
                <div class="flex-grow-1">
                  <div class="d-flex align-items-center gap-2 mb-1">
                    <i class="flaticon-users"></i>
                    <h5 class="mb-0 fw-bold">{{ queue.name }}</h5>
                  </div>
                  <p class="mb-0 small">
                    <strong>Code:</strong> {{ queue.code }}
                    <span class="ms-2"> {{ queue.pays?.name_fr }} - {{ queue.port?.nomPort }}</span>
                  </p>
                </div>
                <div class="text-end">
                  <div class="dossiers-badge">
                    <strong>{{ getBescsCount(queue.id) }} dossiers</strong>
                  </div>
                </div>
              </div>

              <!-- Liste des BESCs dans cette file -->
              <div class="queue-card-body">
                <div v-if="getBescsByQueue(queue.id).length === 0" class="text-center py-3 text-muted">
                  <i class="flaticon-folder-open"></i>
                  <p class="mb-0 small">Aucun dossier dans cette file</p>
                </div>


                <div v-else class="row g-2">
                  <div v-for="besc in getBescsByQueue(queue.id)" :key="besc.id" class="col-12 col-md-4">
                    <div class="besc-item d-flex flex-column gap-1" @click="viewBescDetail(besc.id)">
                      <div class="d-flex justify-content-between align-items-center">
                        <strong>{{ besc.refbesc }}</strong>
                        <span v-if="besc.flagsCount > 0" class="badge bg-danger rounded-pill">
                          <i class="flaticon-flag"></i> {{ besc.flagsCount }} flags
                        </span>
                        <span v-else class="badge bg-success rounded-pill">OK</span>
                      </div>
                      <small class="text-muted">
                        <i class="flaticon-calendar me-1"></i>
                        {{ format_Date(besc.createdAt) }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { error, format_Date } from "@/utils/utils"; // showSuccess supprimé car plus utile sans refresh
import { useRouter } from "vue-router";
import { BescInQueue } from "@/models/BescInQueue";
import { ValidationQueues } from "@/models/ValidationTask";


export default defineComponent({
  name: "ValidationQueuesView",
  setup() {
    const router = useRouter();
    const queues = ref<ValidationQueues[]>([]);
    const bescs = ref<BescInQueue[]>([]);

   async function loadQueues() {
  try {
    const { data } = await ApiService.get("/validation-queues");
    queues.value = data.data || [];
    
    // ← Ajouter ceci pour voir ce que le backend envoie
    queues.value.forEach(q => {
      console.log(q.name, '→ maxRiskLevel:', q.maxRiskLevel)
    })
    
    await loadBescsInQueues();
  } catch (err: any) {
    error(err.response?.data?.message || "Erreur de chargement des files");
  }
}

    async function loadBescsInQueues() {
      try {
        const { data } = await ApiService.get("/bescs/in-queues");
        bescs.value = data.data || [];
      } catch (err: any) {
        console.error("Erreur chargement BESCs:", err);
      }
    }

  const searchRef = ref('');

function getBescsByQueue(queueId: string): BescInQueue[] {
  return bescs.value.filter(b => {
    const matchQueue = b.queueId === queueId;
    const matchRef = searchRef.value
      ? b.refbesc?.toLowerCase().includes(searchRef.value.toLowerCase())
      : true;
    return matchQueue && matchRef;
  });
}

    function getBescsCount(queueId: string): number {
      return getBescsByQueue(queueId).length;
    }
    const queuesWithDossiers = computed(() => {
  return queues.value.filter(q => getBescsCount(q.id) > 0);
});
    
    function getRiskCardClass(riskLevel: string): string {
      const classes = {
        'HIGH': 'risk-high',
        'MEDIUM': 'risk-medium',
        'LOW': 'risk-low'
      };
      return classes[riskLevel] || 'risk-low';
    }

    function viewBescDetail(bescId: string) {
      router.push(`/view-besc/${bescId}`);
    }

    onMounted(() => {
      loadQueues();
    });

    return {
      queues,
      bescs,
      getBescsByQueue,
      getBescsCount,
      getRiskCardClass,
      viewBescDetail,
      format_Date,
      searchRef,
      queuesWithDossiers
    };
  }
});
</script>

<style scoped>
.queues-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.queue-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.queue-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}


.queue-card.risk-high .queue-card-header {
  background: #ffe5e5;
}

.queue-card.risk-high .queue-card-header h5,
.queue-card.risk-high .queue-card-header p,
.queue-card.risk-high .queue-card-header i {
  color: #721c24;
}


.queue-card.risk-medium .queue-card-header {
  background: #fff8e1;
}

.queue-card.risk-medium .queue-card-header h5,
.queue-card.risk-medium .queue-card-header p,
.queue-card.risk-medium .queue-card-header i {
  color: #856404;
}



.queue-card.risk-low .queue-card-header {
  background: #e8f5e9;
}

.queue-card.risk-low .queue-card-header h5,
.queue-card.risk-low .queue-card-header p,
.queue-card.risk-low .queue-card-header i {
  color: #155724;
}

.queue-card-header {
  padding: 1.25rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.queue-card-header h5 {
  font-size: 1.1rem;
  margin: 0;
}

.queue-card-header .dossiers-badge {
  background: rgba(255, 255, 255, 0.7);
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.95rem;
}

.queue-card-body {
  padding: 0.75rem 1.25rem 1.25rem;
}

.bescs-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.besc-item {
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  height: 100%; 
}

.besc-item:hover {
  background: #e9ecef;
  border-color: #dee2e6;
  transform: translateY(-3px); 
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.besc-item strong {
  color: #212529;
  font-size: 0.95rem;
}

.besc-item .badge {
  font-size: 0.75rem;
  padding: 0.35rem 0.65rem;
}

/* Responsive */
@media (max-width: 768px) {
  .queue-card-header {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .queue-card-header .text-end {
    text-align: left !important;
    margin-top: 0.5rem;
  }
}
</style>